import { __ } from "@wordpress/i18n";
import { createContext, useContext, useState } from "react";

const MenuContext = createContext();

const menuData = [
	{
		title: __("Login", "ultimate-security"),
		url: "/login",
		icon: ultimate_security_ajax_obj.imageUrl+"Login.svg",
		page: {
			title: __("Active Logins", "ultimate-security"),
			description: __("Easily manage and monitor login sessions for your users with advanced controls to enhance security and prevent unauthorized access.", "ultimate-security"),
		},
		sub: [
			
			{
				title: __("Active Logins", "ultimate-security"),
				url: "/login/active-logins",
				page: {
					title: __("Active Logins", "ultimate-security"),
					description:
						__("Easily manage and monitor login sessions for your users with advanced controls to enhance security and prevent unauthorized access.", "ultimate-security"),
				},
				sub: [
					{
						title: __("Settings", "ultimate-security"),
						url: "/login/active-logins/settings",
					},
					{
						title: __("Automations", "ultimate-security"),
						url: "/login/active-logins/automations",
					},
					{
						title: __("Current Sessions", "ultimate-security"),
						url: "/login/active-logins/current-sessions",
					},
				],
			},
			{
				title: __("Login Security", "ultimate-security"),
				url: "/login/login-security",
				page: {
					title: __("Login Security", "ultimate-security"),
					description:
						"Below you will find a list of advance security options related to login of your WordPress site that reinforces the integrity of your site. All the features add common security implementation and can easily be implemented via easy to understand customization options.",
				},
				sub: [
					{
						title: __("Login URL", "ultimate-security"),
						url: "/login/login-security/login-url",
					},
					{
						title: __("Password Policies", "ultimate-security"),
						url: "/login/login-security/password-policies",
					},
					
					{
						title: __("Use Administration Password","ultimate-security"),
						url: "/login/login-security/use-admin-password",
					},
					
				],
			},
			{
				title: __("Express Login", "ultimate-security"),
				url: "/login/express-login",
				
				page: {
					title: __("Express Login", "ultimate-security"),
					description:
						"Easily manage and monitor login sessions for your users with advanced controls to enhance security and prevent unauthorized access.",
				},
				sub: [
					{
						title: __("Settings", "ultimate-security"),
						url: "/login/express-login/settings",
					},
					
				],
			},
			{
				title: __("Temporary Login", "ultimate-security"),
				url: "/login/temporary-login",
				page: {
					title: __("Temporary Login", "ultimate-security"),
					description:
						"Easily manage temporary logins for secure, time-limited access to your WordPress site. Simplify collaboration while maintaining full control over who can access your store.",
				},
				sub: [
					{
						title: __("Create Temporary Login","ultimate-security"),
						url: "/login/temporary-login/create",
					},
					{
						title: __("Settings", "ultimate-security"),
						url: "/login/temporary-login/settings",
					},
					
				],
			},
			

			{
				title: __("2FA", "ultimate-security"),
				url: "/login/2fa",
				page: {
					title: __("2FA", "ultimate-security"),
					description:
						"Below you will find a list of advance security options related to login of your WordPress site that reinforces the integrity of your site. All the features add common security implementation and can easily be implemented via easy to understand customization options.",
				},
				sub: [
					
					{
						title: __("Settings","ultimate-security"),
						url: "/login/2fa/settings",
					},
					{
						title: __("User List", "ultimate-security"),
						url: "/login/2fa/user-list",
					},
					
				],
			},
			
			ultimate_security_ajax_obj.isPro && ({
				title: __("Passkeys", "ultimate-security"),
				url: "/login/passkeys",
				page: {
					title: __("Passkeys", "ultimate-security"),
					description:
						"Secure Passkeys is a passwordless authentication solution based on WebAuthn, enabling users to log in using device-based methods like biometrics or PIN. It eliminates the need for traditional passwords, enhancing security and and upgrade your WordPress site with Secure Passkeys for a modern, secure, and efficient authentication experience.",
				},
				sub: [
					{ title: __("Overview", "ultimate-security"), url: "/login/passkeys/overview" },
					{ title: __("Passkeys", "ultimate-security"), url: "/login/passkeys/passkeys" },
					{ title: __("Activity Log", "ultimate-security"), url: "/login/passkeys/activity-log" },
					{ title: __("Settings", "ultimate-security"), url: "/login/passkeys/settings" },
					{ title: __("Display", "ultimate-security"), url: "/login/passkeys/display" },
					{ title: __("Advanced", "ultimate-security"), url: "/login/passkeys/advanced" },
				],
			})
			
				
		],
	},

	{
		title: __("Security", "ultimate-security"),
		url: "/security",
		icon: ultimate_security_ajax_obj.imageUrl+"Security.svg",
		page: {
			title: "Security",
			description:
						"Protect your sensitive information with cutting-edge security measures designed to safeguard your website. Implement robust encryption, prevent unauthorized access, and block potential threats before they arise. Whether it's user data, transaction details, or confidential content, ensure your information remains private, secure, and uncompromised at all times.",
		},
		sub: [
			{
				title: __("Site Security", "ultimate-security"),
				url: "/security/site-security",
				page: {
					title: __("Site Security", "ultimate-security"),
					description:
						"Protect your sensitive information with cutting-edge security measures designed to safeguard your website. Implement robust encryption, prevent unauthorized access, and block potential threats before they arise. Whether it's user data, transaction details, or confidential content, ensure your information remains private, secure, and uncompromised at all times.",
				},
				sub: [
					{
						title: __("reCAPTCHA", "ultimate-security"),
						url: "/security/site-security/re-captcha",
					},
					{
						title: __("Cloudflare Turnstile", "ultimate-security"),
						url: "/security/site-security/cloudflare-turnstile",
						page: {
							title: "Cloudflare Turnstile",
							description:
								'Easily add the free CAPTCHA service called "Cloudflare Turnstile" to your WordPress forms to help prevent spam.',
						},
					},
					{
					  title: __("Login Limit", "ultimate-security"),
					  url: "/security/site-security/login-limit",
					  page: {
					    title: "Login Limit Settings",
					    description: "Limit the number of login attempts to prevent brute-force attacks and ensure the security of your login process."
					  }
					},
				],
			},
			{
				title: __("Data Security", "ultimate-security"),
				url: "/security/data-security",
				page: {
					title: __("Data Security", "ultimate-security"),
					description:
						"Protect your sensitive information with cutting-edge security measures designed to safeguard your website. Implement robust encryption, prevent unauthorized access, and block potential threats before they arise. Whether it's user data, transaction details, or confidential content, ensure your information remains private, secure, and uncompromised at all times.",
				},
				sub: [
					{
						title: __("Disable Right Click", "ultimate-security"),
						url: "/security/data-security/disable-right-click",
					},
					
				],
			},
			{
				title: __("Blacklist Manager", "ultimate-security"),
				url: "/security/blacklist-manager",
				page: {
					title: __("Blacklist", "ultimate-security"),
					description:
						"Protect your sensitive information with cutting-edge security measures designed to safeguard your website. Implement robust encryption, prevent unauthorized access, and block potential threats before they arise. Whether it's user data, transaction details, or confidential content, ensure your information remains private, secure, and uncompromised at all times.",
				},
				sub: [
					
					{
						title: __("Email Blacklist", "ultimate-security"),
						url: "/security/blacklist-manager/email-blacklist",
					},
					{
						title: __("Address Blacklist", "ultimate-security"),
						url: "/security/blacklist-manager/address-blacklist",
					},
				],
			},
			{
				title: __("Salt Change", "ultimate-security"),
				url: "/security/salt-change",
				page: {
					title: __("Salt Changing Behaviour", "ultimate-security"),
					description:
						"WordPress salt keys, or security keys, are essential for safeguarding your website's sensitive data. They strengthen password encryption, making it tougher for hackers to compromise your site. With Ultimate Security for WooCommerce, you don't have to manage these keys yourself—it automatically generates them using the WordPress API, ensuring seamless protection for your site.",
				},
				sub: [
					{
						title: __("Settings", "ultimate-security"),
						url: "/security/salt-change/settings",
					},
				],
			},
			
			
			
			{
				title: __("Privacy Manager", "ultimate-security"),
				url: "/security/privacy-manager",
				page: {
					title: __("Privacy Manager", "ultimate-security"),
					description:
						"Protect your sensitive information with cutting-edge security measures designed to safeguard your website. Implement robust encryption, prevent unauthorized access, and block potential threats before they arise. Whether it's user data, transaction details, or confidential content, ensure your information remains private, secure, and uncompromised at all times.",
				},
				sub: [
					{
						title: __("API Privacy", "ultimate-security"),
						url: "/security/privacy-manager/api-privacy",
					},
					
				],
			},
			
			{
				title: __("Update Manager", "ultimate-security"),
				url: "/security/update-manager",
				page: {
					title: __("Update Manager", "ultimate-security"),
					description:
						"Protect your sensitive information with cutting-edge security measures designed to safeguard your website. Implement robust encryption, prevent unauthorized access, and block potential threats before they arise. Whether it's user data, transaction details, or confidential content, ensure your information remains private, secure, and uncompromised at all times.",
				},
			},

			{
				title: __("URL Guard", "ultimate-security"),
				url: "/security/injection_guard",
				page: {
					title: __("URL Guard", "ultimate-security"),
					description:
						"Customize and protect your URL parameters using ultimate security URL guard and keep your site secure.",
				},
				sub: [
					{
						title: __("Overview", "ultimate-security"),
						url: "/security/injection_guard/overview",
						page: {
							title: "Overview",
							description:
								"Customize and protect your URL parameters using ultimate security URL guard and keep your site secure.",
						},
					},
					{
						title: __("Request logs", "ultimate-security"),
						url: "/security/injection_guard/requests_log",
						page: {
							title: "Request Logs",
							description:
								"See a complete overview of your URL requests so that you can take actions on suspicious behaviours.",
						},
					},
					...(
						ultimate_security_ajax_obj.isPro
							? [
								{
									title: __("Query Strings", "ultimate-security"),
									url: "/security/injection_guard/query_strings",
									page: {
										title: "Query Strings",
										description:
											"See a complete overview of your URL requests so that you can take actions on suspicious behaviours.",
									},
								},
								{
									title: __("User Agents", "ultimate-security"),
									url: "/security/injection_guard/user_agents",
									page: {
										title: "User Agents Settings",
										description:
											"Lorem ipsum dolor sit amet, consectetur adipisicing elit. Blanditiis aliquid, nihil veniam magni nemo distinctio dolorum officia nobis ad maxime!",
									},
								},
							]
							: []
					),
				]
				
			},

			{
				title: __("Recommendations", "ultimate-security"),
				url: "/security/recommendations",
				page: {
					title: __("Recomendations", "ultimate-security"),
					description:
						"Protect your sensitive information with cutting-edge security measures designed to safeguard your website. Implement robust encryption, prevent unauthorized access, and block potential threats before they arise. Whether it's user data, transaction details, or confidential content, ensure your information remains private, secure, and uncompromised at all times.",
				},
			},
		],
	},

	{
		title: __("Restrictions", "ultimate-security"),
		url: "/restrictions",
		icon: ultimate_security_ajax_obj.imageUrl+"Restrictions.svg",
		page: {
			title: "Restrictions",
			description: "Below you will find all the settings you need to restrict specific countires and IP addressses that you wish to restrict for your WooCommerce site. The restrictons will be applied to your WooCommerce pages.",
		},
		sub: [

			{
				title: __("IP Restrictions", "ultimate-security"),
				url: "/restrictions/ip-restrictions",
				sub: [
					{
						title: __("Settings", "ultimate-security"),
						url: "/restrictions/ip-restrictions/settings",
						page: {
							title: __("Settings", "ultimate-security"),
							description:
								"Below you will find all the settings you need to restrict specific countires and IP addressses that you wish to restrict for your WooCommerce site. The restrictons will be applied to your WooCommerce pages.",
						},
					},
					
				],
			},
			
		],
	},
	{
		title: __("More", "ultimate-security"),
		url: "/more",
		icon: ultimate_security_ajax_obj.imageUrl+"More.svg",
		page: {
			title: __("More", "ultimate-security"),
			description: "",
		},
		sub: [
			
			{
				title: __("Site Health Info", "ultimate-security"),
				url: "/more/site-health-info",
				page: {
					title: __("Site Health Info", "ultimate-security"),
					description:
						"This page can show you every detail about the configuration of your WordPress website. For any improvements that could be made, see the Site Health Status page.",
				},
			},
			
			{
				title: __("Comments Cleaner", "ultimate-security"),
				url: "/more/comments-cleaner",
				page: {
					title: __("Comments Cleaner", "ultimate-security"),
					description:
						"This page can show you every detail about the configuration of your WordPress website. For any improvements that could be made, see the Site Health Status page.",
				},
			},
				
			{ 
				title: __("Error Notification", "ultimate-security"),
				url: "/more/error-notification",
				page: {
					title: "Error Notification",
					description:
						"Use the following configuration to customize which error notification you would like to receive via your email.",
				},
			},
			{
				title: __("Settings export/import", "ultimate-security"),
				url: "/more/import-export",
				page: {
					title: "Settings export/import",
					description: "Moving to another site, want to keep a backup if your settings of Ulitimate Security? Export or import from here.",
				},
			},
			{
				title: __("Extra", "ultimate-security"),
				url: "/more/extra",
				page: {
					title: "Extra",
					description:
						"These are the extra options for Ultimate Security. Customize them to your requirement.",
				},
			},
			
			
			
		],
	},
	
];
const communityItems = [
	{
		title: __("Feedback", "ultimate-security"),
		url: "https://wordpress.org/support/plugin/ultimate-security/",
		icon: ultimate_security_ajax_obj.imageUrl+"Feedback.svg",
		sub: [],
	},
	{
		title: __("Review", "ultimate-security"),
		url: "https://wordpress.org/support/plugin/ultimate-security/reviews/#new-post",
		icon: ultimate_security_ajax_obj.imageUrl+"Review.svg",
		sub: [],
	},
	{
		title: __("Support Center", "ultimate-security"),
		url: "https://wordpress.org/support/plugin/ultimate-security/",
		icon: ultimate_security_ajax_obj.imageUrl+"SupportCenter.svg",
		sub: [],
	},
	// {
	// 	title: __("Other Plugin", "ultimate-security"),
	// 	url: "/other-plugin",
	// 	icon: ultimate_security_ajax_obj.imageUrl+"OtherPlugin.svg",
	// 	sub: [],
	// },
];

export const MenuProvider = ({ children }) => {
	const [settingData, setSettingData] = useState({});
	const [settingLoading, setSettingLoading] = useState(true);
	const [reload, setReload] = useState(0);
	const [changeCount, setChangeCount] = useState(false);

	return (
		<MenuContext.Provider
			value={{
				settingData,
				setSettingData,
				reload,
				setReload,
				settingLoading,
				menuData,
				communityItems,
				changeCount,
				setChangeCount,
			}}
		>
			{children}
		</MenuContext.Provider>
	);
};

export const useMenu = () => useContext(MenuContext);
